(function (angular, app) {
   "use strict";

   // UIFactory
   angular.module(app.modules.ui.name)
      .service(app.modules.ui.services.alerts, AlertService);

   // Injector
   AlertService.$inject = ["ngDialog", "$window"
   , app.modules.common.services.eventbus
   , app.modules.common.services.functions
   , app.modules.common.constants.appsettings
   ];

   // Function
   function AlertService(ngDialog, $window, ggCoreSvc, ggFunctions, appSettings) {

      //##//--------------------------------------- 
      var classtype = {
         success: "success"
         , warning: "warning"
         , fail : "error"
      }

      var popup = function () {
         this.title = null;
         this.classname = "";
         this.description = "";
         this.buttons = [];

         var _alert = this;

         this.show = function(){
            ngDialog.closeAll();

            var _data = {
               title : _alert.title
               , classname : _alert.classname
               , description : _alert.description
               , buttons: _alert.buttons
            }


            app.Member.Session.pageTemplates.fetch("app/ui/controllers/alert.html").then(function (template) {
               if (isCordova && isCordovaReady) {
                  StatusBar.backgroundColorByHexString(app.Branding.hexModal);
               }

               var _alertDialog = ngDialog.open({
                  template: template
                  , plain: true
                  , closeByEscape: false
                  , closeByDocument: false
                  , showClose: false
                  , className: "alert " + _alert.classname + " slideup"
                  , data: _data
               });
               _alertDialog.closePromise.then(function () {
                  if (isCordova && isCordovaReady) {
                     StatusBar.backgroundColorByHexString(app.Branding.hexBody);
                  }
                  _alert.classname = "";
                  _alert.title = "";
                  _alert.description = "";
                  _alert.buttons = [];
               });
            });
         }
         this.success = function (title, description, btns) {
            _alert.classname = classtype.success;
            _alert.title = title || "Success";
            _alert.description = description || "The process completed.  You can continue.";

            if (!btns) {
               var btn = new button;
               btn.name = "Continue";
               btn.path = "";
               btn.callback = null;
               _alert.buttons.push(btn);
            } else {
               _alert.buttons = btns;
            }
            
            _alert.show();

         }
         this.fail = function (title, description, btns) {
            _alert.classname = classtype.fail;
            _alert.title = title || "Error";
            _alert.description = description || "There was an error completing your request.";

            if (!btns) {
               var btn = new button;
               btn.name = "OK";
               btn.path = "";
               btn.callback = null;
               _alert.buttons.push(btn);
            } else {
               _alert.buttons = btns;
            }
            _alert.show();
         }
         this.warn = function (title, description, btns) {
            _alert.classname = classtype.warning;
            _alert.title = title || "Warning";
            _alert.description = description || "Something is wrong.  You need to fix it.";

            if (!btns) {
               var btn = new button;
               btn.name = "OK";
               btn.path = "";
               btn.callback = null;
               _alert.buttons.push(btn);
            } else {
               _alert.buttons = btns;
            }

            _alert.show();
         }
      }

      var inline = function () {
         this.classname = ""
         this.title = ""
         this.message = ""
         this.isvisible = false;

         var _inline = this;
         this.show = function () {
            _inline.isvisible = true;
         }
         this.hide = function () {
            _inline.title = ""
            _inline.message = ""
            _inline.isvisible = false;
         }
         this.success = function (title, message) {
            _inline.classname = classtype.success;
            _inline.title = title || "Success";
            _inline.message = message || "The process completed.  You can continue.";
            _inline.show();
         }
         this.fail = function (title, message) {
            _inline.classname = classtype.fail;
            _inline.title = title || "Error";
            _inline.message = message || "There was an error processing your request.";
            _inline.show();
         }
         this.warn = function (title, message) {
            _inline.classname = classtype.warning;
            _inline.title = title || "Warning";
            _inline.message = message || "Something is wrong with what you are trying to do.";
            _inline.show();
         }
      }

      var button = function(){
         this.name = "";
         this.path = "";
         this.callback = null;
      }



      //##//--------------------------------------- 

      // Public
      var service = {
         popup: popup
         , inline : inline
         , classtype : classtype
         , button: button
      }

      return service;
   }
}(angular, app));




